
<div style="background-color: #0B0C12;color:white; padding:1%;">
    <h2 mat-dialog-title>Create New Customer</h2>
</div>
<!-- (newCustomer.get('name').value | removeUnderscore | lowercase) (click)="customerDBName()" -->

<div mat-dialog-content>

    <form [formGroup]="newCustomer" (ngSubmit)="addNewCustomer()">

        <div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="2%" style="margin:2%">

            <mat-form-field class="customer" appearance="outline">
                <mat-label>Customer Name</mat-label>
                <input type="text" matInput formControlName="name">
            </mat-form-field> 

            <mat-form-field appearance="outline">
                <mat-label>Customer Of</mat-label>
                <mat-select formControlName="cust_of">
                        <mat-option *ngFor="let choice of cust_of" [value]="choice">
                            {{choice}}
                        </mat-option>
                </mat-select>
            </mat-form-field> 

            <mat-form-field appearance="outline">
                <mat-label>Phone Number</mat-label>
                <input type="text" matInput formControlName="number" >
            </mat-form-field> 

            <mat-form-field appearance="outline">
                <mat-label>Address</mat-label>
                <input type="text" matInput formControlName="address" >
            </mat-form-field> 

            <mat-form-field appearance="outline">
                <mat-label>Opening Balance</mat-label>
                <input type="text" matInput formControlName="opening" >
                <mat-hint style="margin-top: 3%;">If amount is credit, input positive number. If amount is debit, input negative number.</mat-hint>
            </mat-form-field> 

            <div fxLayout="row" fxLayoutAlign="space-around center" style="padding-top:2%;">
                <button mat-raised-button color="warn" class="submitbutton" [disabled]="!newCustomer.valid"> Submit </button>
                <button type="button" mat-raised-button color="warn" class="button" (click)="onReset()"> Reset Fields </button>
            </div>

        </div>

    </form>
</div>

<div mat-dialog-actions style="margin-top: 2%; border-top: 1px solid black;">
    <button type="button" class="btn btn-outline-dark" [mat-dialog-close]="true">Close</button>
</div>